import styled from "styled-components"

export const GradientBG = styled.div`
  height: 270px;
  background: linear-gradient(
    -85deg,
    #f8d208,
    #7bbd04,
    #23d5ab,
    #23a6d5,
    #e73c7e,
    #ee7752
  );
  background-size: 1500% 1500%;

  @media screen and (min-width: 30em) {
    height: 480px;
  }

  @media screen and (min-width: 60em) {
    height: 100%;
  }
`

export const ErrorCode = styled.span`
  color: #fff;
  font-weight: bold;
  font-size: 240px;
  line-height: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  letter-spacing: -35px;
  transform: translate(-50%);
  width: 370px;

  @media screen and (min-width: 30em) {
    font-size: 480px;
    width: 750px;
    bottom: 115px;
    letter-spacing: -60px;

    &.fiveHundredX {
      font-size: 440px;
    }
  }

  @media screen and (min-width: 60em) {
    font-size: 440px;
    top: 300px;
    width: 680px;

    &.fiveHundredX {
      font-size: 410px;
    }
  }

  @media screen and (min-width: 70em) {
    font-size: 480px;
    top: 310px;
    width: 750px;

    &.fiveHundredX {
      font-size: 440px;
    }
  }
`
export const Mask = styled.div`
  background-repeat: no-repeat;
  background-image:
    linear-gradient(to bottom, #000 5px ,transparent 5px),
    radial-gradient(circle at 35% 9%, #fff 20px, transparent 21px),
    radial-gradient(circle at 35% 9%, #000 25px,  transparent 26px),
    radial-gradient(circle at 65% 9%, #fff 20px, transparent 21px),
    radial-gradient(circle at 65% 9%, #000 25px,  transparent 26px),
    linear-gradient(100deg, transparent 40%, #d59d64 40%),
    linear-gradient(-100deg, transparent 40%, #e0a66b 40%);
  background-size: 60%, 100%, 100%, 100%, 100%, 9% 45%, 10% 45%;
  background-position: 50% 0, 0% 0%, 0% 0%, 0% 0%, 0% 0%, 45% 0%, 55% 0%;
  height: 100%;
  position: absolute;
  top: 25%;
  width: 100%;
  
  &:before,
  &:after {
    content: "";
    position: absolute;
  }

  &:before {
    background-color: #222;
    border-radius: 4px;
    box-shadow: 60px 0 0 #222;
    height: 15px;
    left: 25%;
    top: -12px;
    width: 37px;
  }

  &:after {
    background-color: #222;
    border-radius: 4px;
    height: 25px;
    left: 50%;
    transform: translateX(-50%);
    top: 40%;
    width: 66px;
    z-index: 0;
  }

  &.mask-large {
    background-image:
      linear-gradient(to bottom, #000 8px ,transparent 5px),
      radial-gradient(circle at 35% 9%, #fff 40px, transparent 41px),
      radial-gradient(circle at 35% 9%, #000 48px,  transparent 49px),
      radial-gradient(circle at 65% 9%, #fff 40px, transparent 41px),
      radial-gradient(circle at 65% 9%, #000 48px,  transparent 49px),
      linear-gradient(100deg, transparent 40%, #d59d64 40%),
      linear-gradient(-100deg, transparent 40%, #e0a66b 40%);
    background-size: 60%, 100%, 100%, 100%, 100%, 9% 45%, 10% 45%;
    background-position: 50% 0, 0% 0%, 0% 0%, 0% 0%, 0% 0%, 45% 0%, 55% 0%;
  }

  &.mask-large:before {
    box-shadow: 120px 0 0 #222;
    height: 30px;
    top: -20px;
    width: 78px;
  }

  &.mask-large:after {
    height: 50px;
    width: 120px;
  }
}`

export const Screen = styled.div`
  background-color: #f1f1f1;
  background-image:
    /* buttons */ radial-gradient(
      circle at 6px 5px,
      #fd635d 2px,
      transparent 3px
    ),
    radial-gradient(circle at 13px 5px, #febe40 2px, transparent 3px),
    radial-gradient(circle at 20px 5px, #30c947 2px, transparent 3px),
    /* bar */ linear-gradient(to bottom, #c8c8c9 6%, transparent 5%),
    linear-gradient(
      to bottom,
      #f1f1f1 10%,
      transparent 10%,
      transparent 20%,

      #f1f1f1 20%,
      #f1f1f1 25%,
      transparent 25%,
      transparent 50%,

      #f1f1f1 50%,
      #f1f1f1 55%,
      transparent 55%,
      transparent 60%,

      #f1f1f1 60%,
      #f1f1f1 65%,
      transparent 65%,
      transparent 70%,

      #f1f1f1 70%,
      #f1f1f1 75%,
      transparent 75%,
      transparent 80%,

      #f1f1f1 80%,
      #f1f1f1 85%,
      transparent 85%,
      transparent 95%,

      #f1f1f1 95%,
      #f1f1f1 100%
    ),
    linear-gradient(
      to bottom,
      #f1f1f1 10%,
      transparent 10%,
      transparent 30%,
      #f1f1f1 30%,
      #f1f1f1 35%,
      transparent 35%,
      transparent 95%,
      #f1f1f1 95%,
      #f1f1f1 100%
    ),
    linear-gradient(
      to right,
      transparent 5%,
      #e2e2e2 5%,
      #e2e2e2 30%,
      transparent 30%,
      transparent 40%,
      #e2e2e2 40%,
      #e2e2e2 95%,
      transparent 95%,
      transparent 100%
    );

  background-size: 100%, 100%, 100%, 100%, 65%, 30%, 100%;
  background-position: 0 0, 0 0, 0 0, 0 0, 100% 0, 0 0, 0 0;
  background-repeat: no-repeat;
  border: 1px solid #a2a2a2;
  border-radius: 8px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
  height: 150px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  z-index: 1;

  &.screen-large {
    background-image:
      /* buttons */ radial-gradient(
        circle at 8px 8px,
        #fd635d 3px,
        transparent 4px
      ),
      radial-gradient(circle at 18px 8px, #febe40 3px, transparent 4px),
      radial-gradient(circle at 28px 8px, #30c947 3px, transparent 4px),
      /* bar */ linear-gradient(to bottom, #c8c8c9 5%, transparent 5%),
      linear-gradient(
        to bottom,
        #f1f1f1 10%,
        transparent 10%,
        transparent 20%,

        #f1f1f1 20%,
        #f1f1f1 25%,
        transparent 25%,
        transparent 50%,

        #f1f1f1 50%,
        #f1f1f1 55%,
        transparent 55%,
        transparent 60%,

        #f1f1f1 60%,
        #f1f1f1 65%,
        transparent 65%,
        transparent 70%,

        #f1f1f1 70%,
        #f1f1f1 75%,
        transparent 75%,
        transparent 80%,

        #f1f1f1 80%,
        #f1f1f1 85%,
        transparent 85%,
        transparent 95%,

        #f1f1f1 95%,
        #f1f1f1 100%
      ),
      b
        linear-gradient(
          to bottom,
          #f1f1f1 10%,
          transparent 10%,
          transparent 30%,
          #f1f1f1 30%,
          #f1f1f1 35%,
          transparent 35%,
          transparent 95%,
          #f1f1f1 95%,
          #f1f1f1 100%
        ),
      linear-gradient(
        to right,
        transparent 5%,
        #e2e2e2 5%,
        #e2e2e2 30%,
        transparent 30%,
        transparent 40%,
        #e2e2e2 40%,
        #e2e2e2 95%,
        transparent 95%,
        transparent 100%
      );
    background-size: 100%, 100%, 100%, 100%, 65%, 30%, 100%;
    background-position: 0 0, 0 0, 0 0, 0 0, 100% 0, 0 0, 0 0;
    height: 300px;
    top: 320px;
    width: 400px;

    /** IE10+ hack */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      top: 170px;
    }
  }
`
